import { SlidersHorizontal, X } from "lucide-react";

export const BUDGET_RANGES = [
  { id: "below-20", label: "Below ₹20", tier: "Ultra Low", min: 0, max: 20 },
  { id: "20-50", label: "₹20 – ₹50", tier: "Economical", min: 20, max: 50 },
  { id: "50-100", label: "₹50 – ₹100", tier: "Budget", min: 50, max: 100 },
  { id: "100-200", label: "₹100 – ₹200", tier: "Value", min: 100, max: 200 },
  { id: "200-300", label: "₹200 – ₹300", tier: "Mid Range", min: 200, max: 300 },
  { id: "300-400", label: "₹300 – ₹400", tier: "Standard", min: 300, max: 400 },
  { id: "400-600", label: "₹400 – ₹600", tier: "Premium", min: 400, max: 600 },
  { id: "600-1000", label: "₹600 – ₹1000", tier: "Premium Plus", min: 600, max: 1000 },
  { id: "above-1000", label: "Above ₹1000", tier: "Luxury", min: 1000, max: Infinity },
];

export function FilterSidebar({ categories, selectedCategories, onToggleCategory, selectedRanges, onToggleRange, onClear }) {
  const hasActiveFilters = selectedCategories.length > 0 || selectedRanges.length > 0;
  return (
    <aside className="w-full shrink-0 rounded-2xl border border-gray-200 bg-white p-5 lg:w-64" data-testid="catalog-filter-sidebar">
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-semibold text-gray-950">
          <SlidersHorizontal className="h-4 w-4 text-blue-700" /> Filters
        </div>
        {hasActiveFilters ? (
          <button type="button" data-testid="clear-filters-button" aria-label="Clear all filters" onClick={onClear} className="flex items-center gap-1 text-xs font-semibold text-blue-700 transition-colors hover:text-blue-500">
            <X className="h-3 w-3" /> Clear
          </button>
        ) : null}
      </div>
      <section className="border-b border-gray-100 pb-5" data-testid="category-filter-section">
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">Categories</h3>
        {categories.length === 0 ? (
          <p className="text-xs text-gray-400">No categories yet</p>
        ) : (
          <div className="space-y-2">
            {categories.map((category) => (
              <label key={category} className="flex cursor-pointer items-center gap-2 text-sm text-gray-700 transition-colors hover:text-gray-950">
                <input
                  type="checkbox"
                  data-testid={`category-filter-${category}`}
                  checked={selectedCategories.includes(category)}
                  onChange={() => onToggleCategory(category)}
                  className="h-4 w-4 accent-blue-600"
                />
                <span className="flex-1">{category}</span>
              </label>
            ))}
          </div>
        )}
      </section>
      <section className="pt-5" data-testid="budget-filter-section">
        <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">Budget Filter</h3>
        <div className="space-y-2">
          {BUDGET_RANGES.map((range) => (
            <label key={range.id} className="flex cursor-pointer items-center gap-2 text-sm text-gray-700 transition-colors hover:text-gray-950">
              <input
                type="checkbox"
                data-testid={`budget-filter-${range.id}`}
                checked={selectedRanges.includes(range.id)}
                onChange={() => onToggleRange(range.id)}
                className="h-4 w-4 accent-blue-600"
              />
              <span className="flex-1">{range.label}</span>
              <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-gray-500">{range.tier}</span>
            </label>
          ))}
        </div>
      </section>
    </aside>
  );
}
